export default {"src":"/_next/static/media/ageur.588833db.svg","height":156,"width":156,"blurWidth":0,"blurHeight":0};